export default __webpack_public_path__ + "static/media/f20b4f647aff24a8f67f5523908cabd21580209501571.2347e605.webp";